module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/shop_studiosuns_01-916ca0e7156b91951941fb2d6e0481bc.png";